module.exports = __webpack_public_path__ + "img/N6 200X200.5983b23d.png";